'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.socket = socket;

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _socket = require('../actions/socket');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
var initialState = {
	session: undefined,
	actionQueue: []
};

/**
 *
 */
var setSession = function setSession(state, _ref) {
	var session = _ref.session;
	return (0, _reactAddonsUpdate2.default)(state, {
		session: {
			$set: session
		}
	});
};

/**
 *
 */
var queueAction = function queueAction(state, _ref2) {
	var action = _ref2.action;
	return (0, _reactAddonsUpdate2.default)(state, {
		actionQueue: {
			$push: [action]
		}
	});
};

/**
 *
 */
var clearActionQueue = function clearActionQueue(state) {
	return (0, _reactAddonsUpdate2.default)(state, {
		actionQueue: {
			$set: []
		}
	});
};

/**
 *
 */
function socket() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var _ref3 = arguments[1];
	var type = _ref3.type;
	var payload = _ref3.payload;

	switch (type) {
		case _socket.SET_SESSION:
			return setSession(state, payload);

		case _socket.QUEUE_ACTION:
			return queueAction(state, payload);

		case _socket.CLEAR_ACTION_QUEUE:
			return clearActionQueue(state, payload);

		default:
			return state;
	}
}